import React, { Component } from 'react';
import styled from 'styled-components';

const EyesWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
`;

const Screen = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: -100;
`;

const Eye1 = styled.div`
  position: absolute;
  top: ${(props) => (props.imgHeight * 30) / 100}px;
  left: ${(props) => (props.imgWidth * 35) / 100}px;
  width: ${(props) => props.imgWidth / 15}px;
  height: ${(props) => props.imgWidth / 15}px;
  margin: 0 ${(props) => props.imgWidth / 75}px;
  background: #fff;

  border-radius: 50%;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: ${(props) => props.imgWidth / 50}px;
    transform: translate(-50%, -50%);
    width: ${(props) => props.imgWidth / 30}px;
    height: ${(props) => props.imgWidth / 30}px;
    background: #000;
    border-radius: 50%;
  }
`;
const Eye2 = styled.div`
  position: absolute;
  top: ${(props) => (props.imgHeight * 28) / 100}px;
  left: ${(props) => (props.imgWidth * 57) / 100}px;
  width: ${(props) => props.imgWidth / 15}px;
  height: ${(props) => props.imgWidth / 15}px;
  margin: 0 ${(props) => props.imgWidth / 75}px;
  background: #fff;
  border-radius: 50%;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: ${(props) => props.imgWidth / 50}px;
    transform: translate(-50%, -50%);
    width: ${(props) => props.imgWidth / 30}px;
    height: ${(props) => props.imgWidth / 30}px;
    background: #000;
    border-radius: 50%;
  }
`;

export class Eyes extends Component {
  constructor(props) {
    super(props);
    this.Eye1 = React.createRef();
    this.Eye2 = React.createRef();
  }

  componentDidMount() {
    document.body.addEventListener('mousemove', this.handleMouseMove);
  }

  componentWillUnmount() {
    document.body.removeEventListener('mousemove', this.handleMouseMove);
  }

  _eyeTicking = false;

  handleMouseMove = (e) => {
    if (this._eyeTicking) return;
    this._eyeTicking = true;
    requestAnimationFrame(() => {
      this.eyeball(e);
      this._eyeTicking = false;
    });
  };

  eyeball = (e) => {
    if (!this._eyeElements) {
      this._eyeElements = document.querySelectorAll('.eye');
    }
    this._eyeElements.forEach((eye) => {
      let x = eye.getBoundingClientRect().left + eye.clientWidth / 2;
      let y = eye.getBoundingClientRect().top + eye.clientHeight / 2;
      let radian = Math.atan2(e.clientX - x, e.clientY - y);
      let rot = radian * (180 / Math.PI) * -1 + 270;
      eye.style.transform = 'rotate(' + rot + 'deg)';
    });
  };

  render() {
    return (
      <EyesWrapper>
        <Screen />
        <Eye1
          className='eye'
          ref={this.Eye1}
          imgHeight={this.props.imgHeight}
          imgWidth={this.props.imgWidth}
        />
        <Eye2
          className='eye'
          ref={this.Eye2}
          imgHeight={this.props.imgHeight}
          imgWidth={this.props.imgWidth}
        />
      </EyesWrapper>
    );
  }
}

export default Eyes;
